// AmbassadorProgram/AmbassadorProgram.js — "/ambassador-program".
// Carries the .home-page class, so palette, type scale and the container all
// come from homePage.css, the same as the home, student and career centre
// pages. ambassador.css only adds what this page needs on top.
import { Compass, Flame, Rocket, Users } from "lucide-react";

import "../HomePage/homePage.css";
import "./ambassador.css";

import AmbHero from "./AmbHero/AmbHero";
import AmbResponsibilities from "./AmbResponsibilities/AmbResponsibilities";
import AmbVoice from "./AmbVoice/AmbVoice";
import AmbApply from "./AmbApply/AmbApply";
import Seo from "../../seo/Seo";

/* The apply form at the foot of the page, not a mail client. */
const APPLY = "#apply";

/* Tinted chip plus a line icon — the same mark the home page uses for its
   capabilities, rather than the illustrated PNGs this section carried. */
const traits = [
  {
    Icon: Rocket,
    tone: "blue",
    title: "Entrepreneurial mindset",
    text: "You see opportunities everywhere and aren’t afraid to take a risk.",
  },
  {
    Icon: Users,
    tone: "teal",
    title: "Well connected and outgoing",
    text: "You like meeting people, building networks, and sparking excitement.",
  },
  {
    Icon: Compass,
    tone: "violet",
    title: "Strategic vision",
    text: "You think ahead, find solutions, and map a clear path to them.",
  },
  {
    Icon: Flame,
    tone: "coral",
    title: "Scrappy, gritty, eager",
    text: "You take challenges head on, adapt quickly, and keep going.",
  },
];

/* Three rows, hairline between each. The first one carries the figure, which
   is why it is written as a separate `amount` rather than folded into the
   title — everything else on the page is subordinate to it. */
const benefits = [
  {
    amount: "$10,000",
    title: "a semester",
    text: "A stipend that grows with what you build, plus money to put behind your campaigns.",
  },
  {
    title: "A real line on your resume",
    text: "Product strategy at a growing startup, and the results to show for it.",
  },
  {
    title: "Inside a startup",
    text: "A small team that moves quickly, where you see your own work land.",
  },
];

const AmbassadorProgram = () => (
  <div className="home-page amb-page">
    <Seo path="/ambassador-program" />
    {/* Copy left, photograph right. */}
    <AmbHero />

    <AmbResponsibilities />

    <section className="amb-section amb-traits-section">
      <div className="home-container">
        <div className="amb-head">
          <span className="amb-eyebrow">What we look for</span>
          <h2 className="home-section-title">
            What makes a great RAIN ambassador
          </h2>
        </div>

        <ul className="amb-traits-grid">
          {traits.map(({ Icon, tone, title, text }) => (
            <li className="amb-trait" key={title}>
              <span className={`amb-chip amb-chip-${tone}`}>
                <Icon size={20} strokeWidth={1.9} aria-hidden="true" />
              </span>
              <h3 className="amb-card-title">{title}</h3>
              <p className="amb-card-body">{text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* What you get out of it: the ask on the left, the three things you
        leave with stacked on the right with a hairline between each. */}
    <section className="amb-section amb-why-section">
      <div className="home-container amb-why-grid">
        <div className="amb-why-head">
          <span className="amb-eyebrow">Why join</span>

          <h2 className="amb-why-title">What you leave with</h2>

          <p className="amb-why-sub">
            Time on the program leaves you with more than the check,
            though the check is real too.
          </p>

          <a className="amb-btn" href={APPLY}>
            Apply now
          </a>
        </div>

        <ul className="amb-why-list">
          {benefits.map(({ amount, title, text }) => (
            <li className="amb-why-item" key={title}>
              <h3 className="amb-why-name">
                {amount && <span className="amb-why-amount">{amount}</span>}
                {title}
              </h3>
              <p className="amb-why-text">{text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <AmbVoice />

    <AmbApply />
  </div>
);

export default AmbassadorProgram;
